import type { UseQueryResult } from '@tanstack/react-query';
import { useDerivedNetworkContext, useFilterContext } from '@/context';
import { useContentOverviewQuery } from '@/services/revenueApi';
import type { ContentOverviewResponse } from '@/types/content';

/**
 * Content Performance overview query with the page's filter wiring
 * (selected show or all shows).
 */
export const useContentPerformanceOverviewQuery = ({
  enabled,
  dataSource
}: {
  enabled: boolean;
  dataSource?: 'v2'|'v3'
}): UseQueryResult<ContentOverviewResponse, Error> => {
  const { filters } = useFilterContext();
  const { selectedNetwork } = useDerivedNetworkContext();
  // Omit showIds when "all shows" is selected
  const overviewShowIds =
    filters.selectedShows?.length > 0 ? filters.selectedShows : undefined;
  const hasOverviewParams = !!(
    selectedNetwork.id &&
    filters.dateRange.from &&
    filters.dateRange.to
  );

  return useContentOverviewQuery(
    selectedNetwork.id ?? '',
    filters.dateRange.from,
    filters.dateRange.to,
    { enabled: enabled && hasOverviewParams },
    { showIds: overviewShowIds, dataSource: dataSource ?? 'v2' }
  );
};
